import { render } from "./EnrolleeAddSpouseOnboardComponent.vue?vue&type=template&id=88b41cb0&scoped=true"
import script from "./EnrolleeAddSpouseOnboardComponent.vue?vue&type=script&lang=js"
export * from "./EnrolleeAddSpouseOnboardComponent.vue?vue&type=script&lang=js"

import "./EnrolleeAddSpouseOnboardComponent.vue?vue&type=style&index=0&id=88b41cb0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88b41cb0"]])

export default __exports__